import { Component } from '@angular/core';

@Component({
  selector: 'app-real-estate',
  templateUrl: './real-estate.component.html',
  styleUrls: ['./real-estate.component.scss']
})
export class RealEstateComponent {

  selectedFaqIndex: number | null = null;

  faqs = [
    {
      question: '1. Call Management',
      answer: `Efficiently manage all your calling needs with our comprehensive suite of call management features:<br>
  - IVR (Interactive Voice Response): Automate call routing with customizable voice prompts.<br>
  - Auto Dialing Modes: Save time with automated dialing of contact lists.<br>
  - Predictive Dialing Modes: Use advanced algorithms to dial multiple numbers simultaneously.<br>
  - Adaptive Dialing Modes: Adjust dialing speed based on real-time conditions.<br>
  - Manual Dialing: Allow agents to manually dial numbers.<br>
  - Call Management Tools: Manage inbound/outbound calls efficiently.<br>
  - Call Barge: Supervisors can join ongoing calls.<br>
  - Call Transfer: Transfer calls to agents or departments.<br>
  - Call Whisper: Supervisors can guide agents during calls.<br>
  - Do Not Disturb: Set status to avoid interruptions.<br>
  - Voice Broadcasting: Send pre-recorded messages.<br>
  - Preview Dialing: Review customer info before dialing.<br>`
    },
    {
      question: '2. Contact Management',
      answer: `Effectively manage contacts with robust features:<br>
  - Import/Export Contacts: Easily handle lists.<br>
  - Disposition Management: Track call outcomes.<br>
  - Duplicate Detection: Merge duplicate contacts.<br>
  - Objection Handling: Help agents handle common objections.<br>`
    },
    {
      question: '3. Call Recording and Monitoring',
      answer: `Monitor and analyze calls for quality and performance:<br>
  - Agent Performance Metrics: Analyze performance.<br>
  - Lead Performance: Monitor conversion rates.<br>
  - Campaign Performance Metrics: Detailed insights.<br>
  - Call Recording: For quality and training.<br>
  - Live Call Monitoring: Real-time support.<br>
  - Voicemail Detection: Automatically detect voicemails.<br>
  - Real-Time Dashboard: Access real-time data.<br>`
    },
    {
      question: '4. Silent Features',
      answer: `Improve efficiency and security with silent features:<br>
  - Dynamic Number Rotation: Improve answer rates.<br>
  - Disposition Based Call Action: Trigger actions post-call.<br>
  - Agent Number Masking: Enhance privacy.<br>
  - Label Management: Categorize contacts.<br>
  - Agent Initial Greeting Auto-Play: Play greeting on connect.<br>`
    },
    {
      question: '5. Business Reporting',
      answer: `Gain insights with advanced reporting tools:<br>
  - Daily Report: Summarized daily performance.<br>
  - Campaign Analysis: Deep performance insights.<br>
  - Disposition Report: Track call results.<br>
  - Leads Performance: Analyze lead quality.<br>
  - Agent Report: Activity and performance reports.<br>
  - Call Connectivity: Monitor connection rates.<br>
  - Campaign & DID Performance: Detailed success metrics.<br>`
    },
    {
      question: '6. Campaign Performance',
      answer: `Optimize campaign execution and monitoring:<br>
  - Login/Logout: Track agent activity.<br>
  - Team Performance: Monitor team effectiveness.<br>
  - Call Summary: Overview of call outcomes.<br>
  - Call Analysis: Identify call trends.<br>
  - Call in Queue: Monitor waiting calls.<br>
  - Live Call: Track real-time calls.<br>
  - Agent Availability: See real-time status.<br>
  - Call Termination: Analyze call-end reasons.<br>`
    }
  ];
  

  toggleFaq(index: number) {
    this.selectedFaqIndex = this.selectedFaqIndex === index ? null : index;
  }
  

}
